/*
  PLEASE DON'T EDIT THIS FILE.
  IF YOU NEED TO OVERRIDE IT,
  DO IT IN THE COMPONENT.
*/

import { NODE_ENV } from '@src/Constants'
import pluralize from 'pluralize'

const _actionButtonElements = gridConfig => {
  // Here is how to set the action button elements for the grid.
  // You can add as many buttons as you want.
  // The buttons will be displayed in the order they are added.
  // Please do it on the grid file. Don't chantge this file.
  return [
    {
      id: 2,
      text: 'Action 1: P = Read',
      name: 'Action 1: Read',
      permissions: `${gridConfig.permissions}.READ`,
      visible: true,
      onItemClick: 'onActionButtonAnyItemClick'
    },
    {
      id: 3,
      text: 'Action 2: P = Update',
      permissions: `${gridConfig.permissions}.UPDATE`,
      visible: true,
      onItemClick: 'onActionButtonAnyItemClick'
    },
    {
      id: 4,
      text: 'Action 3: P = Delete',
      permissions: `${gridConfig.permissions}.DELETE`,
      visible: true,
      onItemClick: 'onActionButtonAnyItemClick'
    }
  ]
}

const _createButton = (gridConfig, enableInlineEditing, showCreateButton, createButtonMode) => {
  if (!gridConfig.title) {
    throw 'Grid Config is missing a Title'
  }

  const createButton = {
    id: 1,
    text: `Create ${pluralize.singular(gridConfig.title)}`,
    visible: showCreateButton,
    mode: createButtonMode,
    stylingMode: 'outlined',
    type: 'default',
    permissions: `${gridConfig.permissions}.create`,
    enableInlineEditing,
    ...(createButtonMode === 'row'
      ? {
          url: `${gridConfig.buttonsUrl}/create`
        }
      : {
          onClick: 'onActionButtonFirstItemClick'
        })
  }
  return createButton
}

const _editingOptions = (gridConfig, enableInlineEditing, editingMode) => {
  if (!enableInlineEditing) return {}
  const inLineEditing = {
    useIcons: enableInlineEditing,
    editingMode,
    allowAdding: false,
    allowUpdating: true,
    allowDeleting: true,
    formButtons: {
      saveVisible: true,
      saveText: 'Save',
      cancelVisible: true,
      cancelText: 'Cancel',
      closeVisible: false,
      closeText: 'Close'
    },
    permissions: {
      create: `${gridConfig.permissions}.create`,
      read: `${gridConfig.permissions}.read`,
      update: `${gridConfig.permissions}.update`,
      delete: `${gridConfig.permissions}.delete`
    }
    // texts={
    //   confirmDeleteMessage: 'Are you sure you want to delete this record?',
    //   confirmDeleteTitle: 'Delete Confirmation',
    //   editRow: editingOptions.editRowText,
    // }
  }
  return inLineEditing
}

const _filterButtons = selectedItemKeys => {
  const buttons = [
    {
      icon: ' fa-solid fa-globe',
      text: 'All',
      type: 'default',
      visible: true
    },
    {
      icon: 'fa-sharp fa-solid fa-1',
      text: 'One',
      type: 'success',
      visible: true
    },
    {
      icon: 'fa-sharp fa-solid fa-0',
      text: 'None',
      type: 'danger',
      visible: true
    }
  ]
  return {
    props: {
      id: 'order_filters',
      visible: true,
      stylingMode: 'outlined',
      selectedItemKeys
    },
    buttons
  }
}

const _gridNotLoaded = () => {
  return "Couldn't show the grid. Please contact the support team"
}

const _headerFilter = showHeaderFilter => {
  const headerFilter = {
    visible: showHeaderFilter,
    allowSelectAll: true,
    hideSelectAllOnSearch: false,
    showSearch: {
      enabled: true
    }
  }
  return headerFilter
}

const _searchPanel = showFilterRow => {
  const searchPanel = {
    visible: !showFilterRow, // if showFilterRow == true, search this props will be set to false
    // width: '100px',
    placeholder: 'Search...'
  }
  return searchPanel
}

const _validateAndAssignActionButtonsMode = actionButtonsConfig => {
  // Destructure the object to get the required properties
  const { showActionButtons, showFirstButton, showFirstButtonOnly, showCreateButton } = actionButtonsConfig

  // Initialize actionButtonsMode
  let actionButtonsMode = ''
  let isValid = true
  let actionButtonDevMessage = ''

  // Match the object properties with the matrix and assign the result to actionButtonsMode
  if (!showActionButtons && showFirstButton && showFirstButtonOnly && showCreateButton) {
    actionButtonsMode = 'createButtonOnly'
  } else if (!showActionButtons && showFirstButton && showFirstButtonOnly && !showCreateButton) {
    actionButtonsMode = 'oneActionButtonOnly'
  } else if (showActionButtons && showFirstButton && !showFirstButtonOnly && showCreateButton) {
    actionButtonsMode = 'createButtonAndActionButtons'
  } else if (showActionButtons && !showFirstButton && !showFirstButtonOnly && !showCreateButton) {
    actionButtonsMode = 'actionButtonsOnly'
  } else if (!showActionButtons && !showFirstButton && !showFirstButtonOnly && !showCreateButton) {
    actionButtonsMode = 'Nothing'
  } else {
    actionButtonsMode = 'Invalid button configuration. Please contact the support team.'
    if (NODE_ENV !== 'production') {
      actionButtonDevMessage =
        'Dear Developer, please check the actionButtonsConfig in this grid file. This part of the message will not show on production.'
    }
    isValid = false
  }

  // Add actionButtonsMode to the config
  actionButtonsConfig.actionButtonsMode = actionButtonsMode
  actionButtonsConfig.isValid = isValid
  actionButtonsConfig.actionButtonDevMessage = actionButtonDevMessage

  // Return the updated config
  return actionButtonsConfig
}

const _tableViewName = gridRefCurrent => {
  if (!gridRefCurrent) {
    return false
  }
  const gridRefCurrentProps = gridRefCurrent?.props
  return gridRefCurrentProps.tableViewName() || false
}

const _urlButtons = gridConfig => {
  const defaultButtons = [
    {
      height: '25',
      // icon: 'fa-regular fa-eye',
      icon: 'eyeopen',
      name: 'View',
      permissions: `${gridConfig.permissions}.READ`,
      stylingMode: 'text',
      type: 'default',
      url: `${gridConfig.buttonsUrl}`,
      visible: true,
      width: '25'
    },
    {
      height: '25',
      // icon: 'fa-regular fa-pen',
      icon: 'edit',
      name: 'Edit',
      permissions: `${gridConfig.permissions}.UPDATED`,
      stylingMode: 'text',
      type: 'default',
      url: `${gridConfig.buttonsUrl}`,
      urlSuffix: 'edit',
      visible: true,
      width: '25'
    },
    {
      height: '25',
      // icon: 'fa-regular fa-trash-can',
      icon: 'trash',
      name: 'Delete',
      permissions: `${gridConfig.permissions}.DELETE`,
      stylingMode: 'text',
      type: 'danger',
      url: `${gridConfig.buttonsUrl}`,
      urlSuffix: 'delete',
      visible: true,
      width: '25'
    }
  ]
  return defaultButtons
}

export {
  _actionButtonElements,
  _createButton,
  _editingOptions,
  _filterButtons,
  _gridNotLoaded,
  _headerFilter,
  _searchPanel,
  _tableViewName,
  _urlButtons,
  _validateAndAssignActionButtonsMode
}
